var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignatureMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon-xMark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 54.21,
    viewBox: "0 0 20.001 54.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down_long_arrow",
    "data-name": "Down long arrow",
    d: "M0,41.209v-34l9.993,6.136L20,7.209v34l-10,13Zm0-36V0L9.995,6.137,20,0V5.209L9.995,11.16Z",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Cross",
    d: "M16.59,15.656,19.045,13.2a.66.66,0,1,0-.934-.934l-2.455,2.455L13.2,12.267a.66.66,0,0,0-.934.934l2.455,2.455-2.455,2.455a.66.66,0,0,0,.934.934l2.455-2.455,2.455,2.455a.66.66,0,1,0,.934-.934Z",
    transform: "translate(-5.655 21.555)",
    fill: "#cecece"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureMark);
export default __webpack_public_path__ + "static/media/signature-mark.52a01f1d.svg";
export { ForwardRef as ReactComponent };